module.exports = __webpack_public_path__ + "img/no-match-dark.aad86877.svg";